import Vue from 'vue'
import Router from 'vue-router'
import EntryPoint from '@/views/EntryPoint'
import Dashboard from '@/views/Dashboard'
import BoldDashboard from '@/views/Bold-Dashboard'
import DashboardChart from '@/views/DashboardChart'
import Company from '@/views/Company'
import PositionTypes from '@/views/setup/PositionTypes'
import VendorTypes from '@/views/setup/VendorTypes'
import SuiVue from 'semantic-ui-vue'
import Callback from '@/components/Callback'
import Profile from '@/views/Profile'
import AuthInfo from '@/views/AuthInfo'
import People from '@/views/setup/People'
import CompanyPerson from '@/views/setup/CompanyPerson'
import Properties from '@/views/Properties'
import Property from '@/views/setup/Property'
import Vendors from '@/views/setup/Vendors'
import Procedures from '@/views/Procedures'
// import store from '@/store'
import Events from '@/views/Events'
import Correspondence from '@/views/correspondence/Correspondence'
import EventAdd from '@/views/EventAdd'
import EventManage from '@/views/EventManage'
import PickCompanyOfInterest from '@/views/PickCompanyOfInterest'
import Categories from '@/views/setup/Categories'
import PropertyGroups from '@/views/setup/PropertyGroups'
import PropertyGroup from '@/views/setup/PropertyGroup'
import PropertyEventTypeCountReport from '@/views/reports/PropertyEventTypeCount'
import InsuranceClaimReport from '@/views/reports/InsuranceClaimReport'
import { authGuard } from '../auth/authGuard'
import { adminAuthGuard } from '@/auth/adminAuthGuard'
import { rgAdminAuthGuard } from '@/auth/rgAdminAuthGuard'
import DocumentTypes from '@/views/setup/DocumentTypes'
import Notifications from '@/views/setup/Notifications'
import NotificationAdd from '@/views/setup/NotificationAdd'
import Resources from '@/views/Resources'
import RoutineTasks from '@/views/RoutineTasks'
import MyRoutineTasks from '@/views/MyRoutineTasks'
import ExecuteRoutineTask from '@/views/ExecuteRoutineTask'
import RoutineTaskInstanceManage from '@/views/RoutineTaskInstanceManage'
import AddEditClaim from '@/views/AddEditClaim'
import AddEditDamages from '@/views/AddEditDamages'
import InsurancePolicies from '@/views/policies/InsurancePolicies'
import AddEditInsurancePolicy from '@/views/policies/AddEditInsurancePolicy'
import PolicyContainers from '@/views/policies/PolicyContainers'
import AddEditPolicyContainer from '@/views/policies/AddEditPolicyContainer'
import PropertyInsurancePolicies from '@/views/policies/PropertyInsurancePolicies'
import PropertyInsurancePolicyDetails from '@/views/policies/PropertyInsurancePolicyDetails'

Vue.use(Router)
Vue.use(SuiVue)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'EntryPoint',
      component: EntryPoint
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/bold-dashboard',
      name: 'BoldDashboard',
      component: BoldDashboard
    },
    {
      path: '/dashboard-chart',
      name: 'DashboardChart',
      component: DashboardChart
    },
    {
      path: '/company',
      name: 'Company',
      component: Company,
      beforeEnter: authGuard
    },
    {
      path: '/positionTypes',
      name: 'PositionTypes',
      component: PositionTypes,
      beforeEnter: authGuard
    },
    {
      path: '/vendorTypes',
      name: 'VendorTypes',
      component: VendorTypes,
      beforeEnter: authGuard
    },
    {
      path: '/setup/people',
      name: 'People',
      component: People,
      beforeEnter: authGuard
    },
    {
      path: '/setup/companyPerson/:id',
      name: 'CompanyPerson',
      component: CompanyPerson,
      beforeEnter: authGuard
    },
    {
      path: '/setup/documentTypes/',
      name: 'DocumentTypes',
      component: DocumentTypes,
      beforeEnter: authGuard
    },
    {
      path: '/properties',
      name: 'Properties',
      component: Properties,
      beforeEnter: authGuard
    },
    {
      path: '/setup/property/:id',
      name: 'Property',
      component: Property,
      beforeEnter: authGuard
    },
    {
      path: '/setup/categories',
      name: 'Categories',
      component: Categories,
      beforeEnter: authGuard
    },
    {
      path: '/setup/propertyGroups',
      name: 'PropertyGroups',
      component: PropertyGroups,
      beforeEnter: authGuard
    },
    {
      path: '/setup/propertyGroup/:id',
      name: 'PropertyGroup',
      component: PropertyGroup,
      beforeEnter: authGuard
    },
    {
      path: '/vendors',
      name: 'Vendors',
      component: Vendors,
      beforeEnter: authGuard
    },
    {
      path: '/procedures/:cv',
      name: 'Procedures',
      component: Procedures,
      props: true,
      beforeEnter: authGuard
    },
    {
      path: '/callback',
      name: 'Callback',
      component: Callback
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      beforeEnter: authGuard
    },
    {
      path: '/authinfo',
      name: 'AuthInfo',
      component: AuthInfo,
      beforeEnter: authGuard
    },
    {
      path: '/eventAdd',
      name: 'EventAdd',
      component: EventAdd,
      beforeEnter: authGuard
    },
    {
      path: '/addEditClaim/:eventId/:claimId?',
      name: 'AddEditClaim',
      component: AddEditClaim,
      props: true,
      beforeEnter: authGuard
    },
    {
      path: '/addEditDamages',
      name: 'AddEditDamages',
      component: AddEditDamages,
      props: true,
      beforeEnter: authGuard
    },
    {
      path: '/events',
      name: 'EventsAdd',
      component: Events,
      beforeEnter: authGuard
    },
    {
      path: '/correspondence',
      name: 'Correspondence',
      component: Correspondence,
      beforeEnter: authGuard
    },
    {
      path: '/pickCompanyOfInterest',
      name: 'PickCompanyOfInterest',
      component: PickCompanyOfInterest,
      beforeEnter: authGuard
    },
    {
      path: '/eventManage/:id/:tab?',
      name: 'EventManage',
      component: EventManage,
      props: true,
      beforeEnter: authGuard
    },
    {
      path: '/reports/propertyEventTypeCount',
      name: 'PropertyEventTypeCountReport',
      component: PropertyEventTypeCountReport,
      beforeEnter: authGuard
    },
    // DEPRECATED as of 1/12/2026: This route should probably be removed entirely.
    // The Insurance Claim data model has changed significantly with deprecated fields removed
    // and new auto-calculated financial fields added. This report uses the old data model.
    // {
    //   path: '/reports/insuranceClaims',
    //   name: 'InsuranceClaimReport',
    //   component: InsuranceClaimReport,
    //   beforeEnter: authGuard
    // },
    {
      path: '/Notifications',
      name: 'Notifications',
      component: Notifications,
      beforeEnter: authGuard
    },
    {
      path: '/notificationAdd',
      name: 'NotificationAdd',
      component: NotificationAdd,
      beforeEnter: authGuard
    },
    {
      path: '/setup/notification-templates',
      name: 'NotificationTemplates',
      component: () => import('@/views/setup/NotificationTemplates.vue'),
      beforeEnter: authGuard
    },
    {
      path: '/setup/notification-templates/edit/:id?',
      name: 'NotificationTemplateEdit',
      component: () => import('@/views/setup/NotificationTemplateEdit.vue'),
      beforeEnter: authGuard
    },
    {
      path: '/setup/feature-flags',
      name: 'FeatureFlags',
      component: () => import('@/views/setup/FeatureFlags.vue'),
      beforeEnter: rgAdminAuthGuard
    },
    {
      path: '/setup/feature-flags/edit/:identifier',
      name: 'FeatureFlagEdit',
      component: () => import('@/views/setup/FeatureFlagEdit.vue'),
      beforeEnter: rgAdminAuthGuard
    },
    {
      path: '/resources',
      name: 'Resources',
      component: Resources,
      beforeEnter: authGuard
    },
    {
      path: '/routinetasks',
      name: 'RoutineTasks',
      component: RoutineTasks,
      beforeEnter: authGuard
    },
    {
      path: '/myroutinetasks',
      name: 'MyRoutineTasks',
      component: MyRoutineTasks,
      beforeEnter: authGuard
    },
    {
      path: '/executeroutineTask',
      name: 'ExecuteRoutineTask',
      component: ExecuteRoutineTask,
      beforeEnter: authGuard
    },
    {
      path: '/manageroutinetask/:instanceId',
      name: 'RoutineTaskInstanceManage',
      component: RoutineTaskInstanceManage,
      beforeEnter: authGuard
    },
    {
      path: '/insurancepolicies',
      name: 'InsurancePolicies',
      component: InsurancePolicies,
      beforeEnter: authGuard
    },
    {
      path: '/addeditinsurancepolicy/:id?',
      name: 'AddEditInsurancePolicy',
      component: AddEditInsurancePolicy,
      beforeEnter: authGuard
    },
    {
      path: '/policycontainers',
      name: 'PolicyContainers',
      component: PolicyContainers,
      beforeEnter: authGuard
    },
    {
      path: '/addeditpolicycontainer/:id?',
      name: 'AddEditPolicyContainer',
      component: AddEditPolicyContainer,
      beforeEnter: authGuard
    },
    {
      path: '/propertyinsurancepolicies',
      name: 'PropertyInsurancePolicies',
      component: PropertyInsurancePolicies,
      beforeEnter: authGuard
    },
    {
      path: '/propertyinsurancepolicydetails/:id?',
      name: 'PropertyInsurancePolicyDetails',
      component: PropertyInsurancePolicyDetails,
      beforeEnter: authGuard
    },
    // Import & Export routes
    // ⚠ Specific routes MUST come before the :entityType wildcard.
    {
      path: '/import-export',
      name: 'ImportExport',
      component: () => import('@/views/ImportExport.vue'),
      beforeEnter: authGuard
    },
    {
      path: '/import-export/insurance-policies',
      name: 'ImportExportInsurancePolicies',
      component: () => import('@/views/ImportExportInsurancePolicies.vue'),
      beforeEnter: authGuard
    },
    {
      path: '/import-export/events',
      name: 'ImportExportEvents',
      component: () => import('@/views/ImportExportEvents.vue'),
      beforeEnter: authGuard
    },
    {
      path: '/import-export/:entityType',
      name: 'ImportExportEntity',
      component: () => import('@/views/ImportExportEntity.vue'),
      props: true,
      beforeEnter: authGuard
    },
    // Admin routes
    {
      path: '/admin/companies',
      name: 'AdminCompanies',
      component: () => import('@/views/admin/Companies.vue'),
      beforeEnter: adminAuthGuard
    },
    {
      path: '/admin/company/:id/edit',
      name: 'AdminCompanyEdit',
      component: () => import('@/views/admin/EditCompany.vue'),
      beforeEnter: adminAuthGuard
    },

    // ─── Public routes — NO auth guard ──────────────────────────────────────────
    // The /collection/:shareId specific route MUST come before the /:token wildcard
    // so Vue Router does not swallow "collection" as a token value.
    {
      path: '/share/:companyId/collection/:shareId',
      name: 'PublicShareView',
      component: () => import('@/views/PublicShareView.vue')
    },
    {
      path: '/share/:companyId/:token',
      name: 'PublicFileView',
      component: () => import('@/views/PublicFileView.vue')
    }
  ]
})

/* router.beforeEach((to, from, next) => {
  if (to.path === '/' || to.path === '/callback' || auth.isAuthenticated()) {
    store.commit('setLoading', true)
    return next()
  }

  auth.login({
    target: to.path
  })
}) */

/* router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
  store.commit('setLoading', false)
}) */

export default router
